// Reinspection Image Upload Module
const ReinspectionImageUpload = (function() {
    let imageState = { capture: false, lat: null, long: null };

    function formatTimestamp(date = new Date()) {
        let time = date.toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true
        }).toLowerCase();

        let fullDate = date.toLocaleDateString("en-US", {
            month: "long",
            day: "numeric",
            year: "numeric"
        });

        let weekday = date.toLocaleDateString("en-US", {
            weekday: "long"
        });

        return `${time} | ${fullDate} | ${weekday}`;
    }

    async function getLocation() {
        try {
            const data = await $.ajax({
                url: "/health_inspections/get_location",
                data: { lat: imageState.lat, long: imageState.long },
                method: "GET",
                dataType: "json"
            });

            if (data) {
                return { success: true, location: data.location || 'Location not found' };
            } else {
                return { success: false, error: "Invalid response format" };
            }
        } catch (e) {
            return { success: false, error: "Failed to get location" };
        }
    }

    async function extractImageInfo(file) {
        const formData = new FormData();
        formData.append('file', file);
        try {
            const data = await $.ajax({
                url: '/health_inspections/extract_image_info',
                type: 'POST',
                data: formData,
                processData: false,
                contentType: false,
                dataType: 'json',
                headers: {
                    'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
                }
            });

            if (data && data.metadata) {
                return { success: true, ...data.metadata };
            } else {
                return { success: false, date_time_original: null, date_time_original_iso: null, location: null };
            }
        } catch (e) {
            return { success: false, date_time_original: null, date_time_original_iso: null, location: null };
        }
    }

    async function getImageMetadata(imageInfo) {
        let timestamp, timestampDisplay, location;

        if (imageInfo.date_time_original_iso) {
            timestamp = imageInfo.date_time_original_iso;
            timestampDisplay = imageInfo.date_time_original || null;
            location = imageInfo.location || null;
        } else if (imageState.capture === false) {
            timestamp = null;
            timestampDisplay = null;
            location = imageInfo.location || null;
        } else {
            const now = new Date();
            timestamp = now.toISOString();
            timestampDisplay = formatTimestamp(now);

            const locationData = await getLocation();
            location = locationData.success ? locationData.location : null;
        }

        return {
            timestamp: timestamp,
            timestampDisplay: timestampDisplay,
            location: location
        };
    }

    function requestLocation() {
      if (!("geolocation" in navigator)) {
          console.error("Geolocation is not supported by your browser.");
          return;
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          imageState.lat = position.coords.latitude;
          imageState.long = position.coords.longitude;
        },
        (error) => {
          console.error("Error getting location:", error.message);
        }
      );
    }

    return {
      getState: function() { return imageState; },
      setState: function(key, value) { imageState[key] = value; },
      requestLocation: requestLocation,
      extractImageInfo: extractImageInfo,
      getImageMetadata: getImageMetadata
    };
})();

function updateReinspectionNumbers(followUpForm) {
  $(followUpForm).find('.reinspection-form:visible').each(function(index) {
    $(this).find('.reinspection-number span').text('Inspection ' + (index + 1));
  });

  // Update reinspection count in header
  var count = $(followUpForm).find('.reinspection-form:visible').length;
  $(followUpForm).closest('.follow-up').find('.reinspection-count').text(count + ' Re-inspections');
}

function initializeImageUploadHandlers(reinspectionForm) {
  const ceImagesSection = $(reinspectionForm).find('.ceImagesSection');
  const uploadBtn = $(reinspectionForm).find('.uploadCeImageBtn');
  const captureBtn = $(reinspectionForm).find('.reinspection-capture-image-btn');
  const fileField = $(reinspectionForm).find('.uploadCeImageField');
  const captureField = $(reinspectionForm).find('.captureCeImageField');
  const addImageBtn = $(reinspectionForm).find('.addImageRowBtn');

  function createImageRow(file, metadata = {}) {
    var mouseEvt = new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window
    });
    addImageBtn[0].dispatchEvent(mouseEvt);

    let targetEle = $(ceImagesSection).find('.file-field').last();
    let nestedField = $(targetEle).closest('.nested-fields');
    let imageContainer = $(targetEle).closest('.image-container');
    let imageCard = $(targetEle).closest('.ce-reinspection-image-card');

    let newImage = document.createElement('img');
    newImage.src = URL.createObjectURL(file);
    newImage.className = 'image-section';
    imageContainer.prepend(newImage);

    const dataTransfer = new DataTransfer();
    dataTransfer.items.add(file);
    targetEle[0].files = dataTransfer.files;

    // Populate hidden fields with metadata
    if (metadata.timestamp) {
      nestedField.find('.uploaded-at-field').val(metadata.timestamp);
    }
    if (metadata.location) {
      nestedField.find('.location-field').val(metadata.location);
    }

    // Display metadata below the image
    let metadataContainer = imageCard.find('.image-metadata');
    metadataContainer.empty();

    if (metadata.timestampDisplay) {
      metadataContainer.append(`<div class="timestamp-display">${metadata.timestampDisplay}</div>`);
    } else {
      metadataContainer.append(`<div class="timestamp-display">Timestamp not found</div>`);
    }
    if (metadata.location) {
      metadataContainer.append(`<div class="location-display">${metadata.location}</div>`);
    } else {
      metadataContainer.append(`<div class="location-display">Location not found</div>`);
    }

    return targetEle;
  }

  async function handleFileChange(files) {
    if (files && files.length > 0) {
      // Show loading indicator
      const loadingIndicator = document.createElement('div');
      loadingIndicator.className = 'text-center mt-3 reinspection-loading-indicator';
      loadingIndicator.innerHTML = '<div class="spinner-border text-primary" role="status"><span class="visually-hidden">Processing images...</span></div>';
      ceImagesSection.append(loadingIndicator);

      try {
        for (const file of Array.from(files)) {
          const imageInfo = await ReinspectionImageUpload.extractImageInfo(file);
          const metadata = await ReinspectionImageUpload.getImageMetadata(imageInfo);

          let processedFile = file;
          if (file.type.startsWith('image/') && window.compressImage) {
            processedFile = await window.compressImage(file);
          }

          createImageRow(processedFile, metadata);
        }
      } catch (error) {
        console.error('Error processing images:', error);

        // Fallback to original upload without metadata
        Array.from(files).forEach(function (file) {
          createImageRow(file, {});
        });
      } finally {
        $(loadingIndicator).remove();
        ReinspectionImageUpload.setState('capture', false);
      }
    }
  }

  // reattach events
  uploadBtn.off('click');
  captureBtn.off('click');
  fileField.off('change');
  captureField.off('change');

  uploadBtn.on('click', function() {
    ReinspectionImageUpload.setState('capture', false);
    fileField.click();
  });

  captureBtn.on('click', function() {
    ReinspectionImageUpload.setState('capture', true);

    if ('permissions' in navigator) {
      navigator.permissions.query({ name: 'geolocation' }).then(result => {
        if (result.state === 'granted') {
          ReinspectionImageUpload.requestLocation();
          captureField.click();
        } else if (result.state === 'prompt') {
          ReinspectionImageUpload.requestLocation();
          $('#ceLocationAccessModalHeader').text('Location Access Required');
          $('#ceLocationAccessModalBody').html('<p>This app would like to access your location to:</p><ul><li>Add location information to your photos</li><li>Create a timestamp with coordinates</li><li>Provide better photo organization</li></ul><p>Your privacy matters: Location data will only be used for photo tagging and will not be shared with third parties.</p>');
          $('#ceLocationAccessModal').modal('show');
          $('#ceLocationAccessModal').data('fileField', captureField);
        } else if (result.state === 'denied') {
          $('#ceLocationAccessModalHeader').text('Location Access Denied');
          $('#ceLocationAccessModalBody').html('<p>Location access is required. Please enable it in your browser or device settings.</p><p>Without location access there will be no location information on the reinspection images.</p><p>However you can continue taking pictures.</p><a href="https://support.google.com/chrome/answer/142065?hl=en&co=GENIE.Platform%3DAndroid&oco=0" target=_blank style="text-decoration: none">How to enable location?</a>');
          $('#ceLocationAccessModal').modal('show');
          $('#ceLocationAccessModal').data('fileField', captureField);
        }
      });
    } else {
      ReinspectionImageUpload.requestLocation();
      captureField.click();
    }
  });

  fileField.on('change', async function(evt) {
    await handleFileChange(evt.target.files);
  });

  captureField.on('change', async function(evt) {
    await handleFileChange(evt.target.files);
  });
}

function initializeCustomMultiselect(reinspectionForm) {
  $(reinspectionForm).find('.custom-multiselect').each(function() {
    var $multiselect = $(this);
    var $select = $multiselect.closest('.reinspection-field').find('.violation-select');
    var $chipsContainer = $multiselect.find('.selected-chips');
    var $selectFieldContainer = $multiselect.find('.select-field-container');
    var $chipsInlineContainer = $selectFieldContainer.find('.selected-chips-inline');
    var $checkboxPanel = $multiselect.find('.checkbox-panel');
    var $chevron = $selectFieldContainer.find('.fa-chevron-down');

    $multiselect.off('click', '.chip-remove');
    $selectFieldContainer.off('click');
    $checkboxPanel.off('change', '.violation-checkbox');
    $checkboxPanel.off('click');

    // Render chips and update checkboxes
    function renderChips() {
      $chipsContainer.empty();
      $chipsInlineContainer.empty();
      var selectedValues = $select.val() || [];

      selectedValues.forEach(function(value) {
        if (value) {
          var $chip = $('<span class="violation-chip"></span>')
            .append($('<span></span>').text(value))
            .append($('<i class="fa fa-times chip-remove"></i>').attr('data-value', value));
          $chipsContainer.append($chip.clone());
          $chipsInlineContainer.append($chip);
        }
      });

      // Show/hide placeholder
      if (selectedValues.length > 0) {
        $selectFieldContainer.addClass('has-selection');
      } else {
        $selectFieldContainer.removeClass('has-selection');
      }

      updateCheckboxes();
    }

    // Update checkbox states based on selected values
    function updateCheckboxes() {
      var selectedValues = $select.val() || [];
      $checkboxPanel.find('.violation-checkbox').each(function() {
        $(this).prop('checked', selectedValues.indexOf($(this).data('value')) !== -1);
      });
    }

    // Update selection and refresh UI
    function updateSelection(selectedValues) {
      $select.val(selectedValues).trigger('change');
      renderChips();
    }

    // Toggle panel and chevron
    function togglePanel(show) {
      $checkboxPanel.toggle(show);
      $chevron.css('transform', $checkboxPanel.is(':visible') ? 'translateY(-50%) rotate(180deg)' : 'translateY(-50%) rotate(0deg)');
    }

    // Remove chip on click
    $multiselect.on('click', '.chip-remove', function(e) {
      e.stopPropagation();
      var selectedValues = $select.val() || [];
      var index = selectedValues.indexOf($(this).attr('data-value'));
      if (index !== -1) {
        selectedValues.splice(index, 1);
        updateSelection(selectedValues);
      }
    });

    // Toggle panel on field container click
    $selectFieldContainer.on('click', function() {
      togglePanel();
    });

    // Update selection on checkbox change
    $checkboxPanel.on('change', '.violation-checkbox', function(e) {
      e.stopPropagation();
      var value = $(this).data('value');
      var selectedValues = $select.val() || [];

      if ($(this).prop('checked')) {
        if (selectedValues.indexOf(value) === -1) {
          selectedValues.push(value);
        }
      } else {
        var index = selectedValues.indexOf(value);
        if (index !== -1) {
          selectedValues.splice(index, 1);
        }
      }

      updateSelection(selectedValues);
    });

    // Prevent panel from closing when clicking inside
    $checkboxPanel.on('click', function(e) {
      e.stopPropagation();
    });

    // Close panel when clicking outside - scoped to follow-up container
    var $followUpContainer = $multiselect.closest('#follow-up-accordion');
    if ($followUpContainer.length === 0) {
      $followUpContainer = $(document); // Fallback if container not found
    }

    // Use namespace to allow cleanup and avoid conflicts
    var multiselectId = $multiselect[0].id || ('multiselect-' + Math.random().toString(36).substr(2, 9));
    if (!$multiselect[0].id) {
      $multiselect.attr('id', multiselectId);
    }
    var eventNamespace = '.ce-follow-ups-multiselect-' + multiselectId;

    $followUpContainer.off('click' + eventNamespace);

    $followUpContainer.on('click' + eventNamespace, function(e) {
      // Only close this specific multiselect's panel if click is outside it
      if (!$(e.target).closest($multiselect).length) {
        togglePanel(false);
      }
    });

    // Initialize
    renderChips();
  });
}

function initializeDatePickers(reinspectionForm) {
  $(reinspectionForm).find('.date-picker').each(function() {
    if (!this._flatpickr) {
      flatpickr(this, {
        altInput: true,
        altFormat: "m/d/Y",
        dateFormat: "Y-m-d",
        allowInput: true
      });
    }
  });
}

function clearReinspectionFieldErrors(reinspectionForm) {
  $(reinspectionForm).find('.violation-select, .reinspection-visit-date, .reinspection-status-select, .reinspection-compliance-date')
    .removeClass('is-invalid error-field');
  $(reinspectionForm).find('.custom-multiselect .select-field-container').removeClass('is-invalid error-field');
  $(reinspectionForm).find('.reinspection-form-error-message').remove();
}

function showReinspectionFieldError($field, message) {
  $field.addClass('is-invalid error-field');
  var $container = $field.closest('.reinspection-field');
  if ($container.find('.reinspection-form-error-message').length === 0) {
    $container.append('<div class="reinspection-form-error-message text-danger small mt-1">' + (message || 'This field is required') + '</div>');
  }
}

function validateReinspectionFields(followUpForm) {
  var isValid = true;
  var firstErrorField = null;
  var $followUpForm = $(followUpForm);

  $followUpForm.find('.reinspection-form:visible').each(function() {
    var $reinspectionForm = $(this);
    clearReinspectionFieldErrors(this);

    // at least one selected
    var $violationSelect = $reinspectionForm.find('.violation-select');
    var violationVal = $violationSelect.val();
    var violationValid = Array.isArray(violationVal) ? violationVal.length > 0 : (violationVal && String(violationVal).trim() !== '');
    if (!violationValid) {
      isValid = false;
      var msg = $violationSelect.data('error-message') || 'Please select at least one violation';
      $reinspectionForm.find('.custom-multiselect .select-field-container').addClass('is-invalid error-field');
      var $violationField = $violationSelect.closest('.reinspection-field');
      if ($violationField.find('.reinspection-form-error-message').length === 0) {
        $violationField.append('<div class="reinspection-form-error-message text-danger small mt-1">' + msg + '</div>');
      }
      if (!firstErrorField) {
        firstErrorField = $reinspectionForm.find('.custom-multiselect .select-field-container')[0];
      }
    }

    var $visitDate = $reinspectionForm.find('.reinspection-visit-date');
    var visitDateVal = $visitDate.val();
    var visitDateValid = visitDateVal && String(visitDateVal).trim() !== '';
    if (!visitDateValid) {
      isValid = false;
      showReinspectionFieldError($visitDate, $visitDate.data('error-message'));
      if (!firstErrorField) firstErrorField = $visitDate[0];
    }

    var $statusSelect = $reinspectionForm.find('.reinspection-status-select');
    var statusVal = $statusSelect.val();
    var statusValid = statusVal && String(statusVal).trim() !== '';
    if (!statusValid) {
      isValid = false;
      showReinspectionFieldError($statusSelect, $statusSelect.data('error-message'));
      if (!firstErrorField) firstErrorField = $statusSelect[0];
    }

    // compliance date - required only when status is failed
    if (statusVal === 'failed') {
      var $complianceDate = $reinspectionForm.find('.reinspection-compliance-date');
      var complianceVal = $complianceDate.val();
      var complianceValid = complianceVal && String(complianceVal).trim() !== '';
      if (!complianceValid) {
        isValid = false;
        showReinspectionFieldError($complianceDate, $complianceDate.data('error-message'));
        if (!firstErrorField) firstErrorField = $complianceDate[0];
      }
    }
  });

  return { isValid: isValid, firstErrorField: firstErrorField };
}

function initializeReinspectionForm(reinspectionForm) {
  initializeCustomMultiselect(reinspectionForm);
  initializeDatePickers(reinspectionForm);
  initializeImageUploadHandlers(reinspectionForm);
}

window.initializeReinspectionForm = initializeReinspectionForm;
window.validateReinspectionFields = validateReinspectionFields;
window.updateReinspectionNumbers = updateReinspectionNumbers;
window.initializeCustomMultiselect = initializeCustomMultiselect;

document.addEventListener('turbolinks:load', function () {
  const followUpContainer = $('#follow-up-accordion');
  if ($('.ce_case_follow_ups.index, .ce_case_follow_ups.new, .ce_case_follow_ups.create, .ce_case_follow_ups.edit, .ce_case_follow_ups.update').length === 0 || followUpContainer.length === 0) {
    return false
  }

  followUpContainer.find('.reinspection-form').each(function() {
    initializeReinspectionForm(this);
  });


  followUpContainer.on('cocoon:after-insert', '.follow-up-form', function(_e, insertedItem) {
    if ($(insertedItem).hasClass('reinspection-form')) {
      var form = this;
      setTimeout(function() {
        initializeReinspectionForm(insertedItem);
        updateReinspectionNumbers(form);
      }, 50);
    }
  });

  followUpContainer.on('cocoon:after-remove', '.follow-up-form', function() {
    updateReinspectionNumbers(this);
  });

  followUpContainer.on('change', '.reinspection-status-select', function() {
    var $reinspectionForm = $(this).closest('.reinspection-form');
    var $complianceSection = $reinspectionForm.find('.compliance-fields-section');
    var $complianceDate = $reinspectionForm.find('.reinspection-compliance-date');

    if ($(this).val() === 'failed') {
      $complianceSection.removeClass('d-none');
      $complianceDate.addClass('requiredField');
    } else {
      $complianceSection.addClass('d-none');
      $complianceDate.removeClass('requiredField');
      $complianceDate.removeClass('is-invalid error-field');
      $reinspectionForm.find('.compliance-fields-section .reinspection-form-error-message').remove();
    }
  });

  // validate reinspection fields before follow-up form submit
  followUpContainer.on('submit', '.follow-up-form', function(e) {
    var $form = $(this);
    var validationResult = validateReinspectionFields(this);
    if (!validationResult.isValid) {
      e.preventDefault();
      if (validationResult.firstErrorField) {
        var el = validationResult.firstErrorField;
        if (el && el.scrollIntoView) {
          el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        $(el).focus();
      }
      return false;
    }
  });

  followUpContainer.on('blur', '.reinspection-form .requiredField, .reinspection-form .reinspection-compliance-date', function() {
    var $field = $(this);
    var $reinspectionForm = $field.closest('.reinspection-form');
    var $container = $field.closest('.reinspection-field');
    $container.find('.reinspection-form-error-message').remove();
    if ($field.hasClass('violation-select')) {
      $reinspectionForm.find('.custom-multiselect .select-field-container').removeClass('is-invalid error-field');
      var violationVal = $field.val();
      var violationValid = Array.isArray(violationVal) ? violationVal.length > 0 : (violationVal && String(violationVal).trim() !== '');
      if (!violationValid) {
        $reinspectionForm.find('.custom-multiselect .select-field-container').addClass('is-invalid error-field');
        $container.append('<div class="reinspection-form-error-message text-danger small mt-1">' + ($field.data('error-message') || 'Please select at least one violation') + '</div>');
      }
    } else {
      $field.removeClass('is-invalid error-field');
      $container.find('.reinspection-form-error-message').remove();
      var val = $field.val();
      var valid = val && String(val).trim() !== '';
      var isComplianceDate = $field.hasClass('reinspection-compliance-date');
      var statusFailed = $reinspectionForm.find('.reinspection-status-select').val() === 'failed';
      if ((!isComplianceDate && !valid) || (isComplianceDate && statusFailed && !valid)) {
        showReinspectionFieldError($field, $field.data('error-message'));
      }
    }
  });

  followUpContainer.on('change', '.reinspection-form .violation-select, .reinspection-form .reinspection-status-select', function() {
    var $field = $(this);
    var $reinspectionForm = $field.closest('.reinspection-form');
    var $container = $field.closest('.reinspection-field');
    $container.find('.reinspection-form-error-message').remove();
    if ($field.hasClass('violation-select')) {
      $reinspectionForm.find('.custom-multiselect .select-field-container').removeClass('is-invalid error-field');
      var violationVal = $field.val();
      var violationValid = Array.isArray(violationVal) ? violationVal.length > 0 : (violationVal && String(violationVal).trim() !== '');
      if (!violationValid) {
        $reinspectionForm.find('.custom-multiselect .select-field-container').addClass('is-invalid error-field');
        $container.append('<div class="reinspection-form-error-message text-danger small mt-1">' + ($field.data('error-message') || 'Please select at least one violation') + '</div>');
      }
    } else if ($field.hasClass('reinspection-status-select')) {
      $field.removeClass('is-invalid error-field');
      if (!$field.val() || String($field.val()).trim() === '') {
        showReinspectionFieldError($field, $field.data('error-message'));
      }
    }
  });

  followUpContainer.on('input change', '.reinspection-form .reinspection-visit-date, .reinspection-form .reinspection-compliance-date', function() {
    var $field = $(this);
    var val = $field.val();
    if (val && String(val).trim() !== '') {
      var $container = $field.closest('.reinspection-field');
      $container.find('input').removeClass('is-invalid error-field');
      $container.find('.reinspection-form-error-message').remove();
    }
  });

  $('#reinspection-location-denied-warning').off('click.ce-follow-ups').on('click.ce-follow-ups', function() {
    $('#reinspection-location-permission-denied-warning').addClass('d-none');
  });

  $('#ce-go-to-capture').off('click.ce-follow-ups').on('click.ce-follow-ups', function() {
    $('#ceLocationAccessModal').modal('hide');
    let $fileField = $('#ceLocationAccessModal').data('fileField');
    if ($fileField) {
      $fileField.click();
    }
  });

  // Handle edit toggle for read-only follow-ups
  $(document).off('click', '.edit-follow-up-link').on('click', '.edit-follow-up-link', function(e) {
    e.preventDefault();
    var $link = $(this);
    var followUpId = $link.data('follow-up-id');
    var $form = $('#follow-up-form-' + followUpId);

    if ($form.length === 0) {
      return;
    }

    var formAction = $form.attr('action');
    var match = formAction.match(/code_enforcements\/(\d+)\/ce_case_follow_ups/);
    if (!match) {
      return;
    }
    var codeEnforcementId = match[1];

    // reload form in edit mode
    $.ajax({
      url: '/code_enforcements/' + codeEnforcementId + '/ce_case_follow_ups/' + followUpId + '/edit',
      method: 'GET',
      dataType: 'script',
      success: function() {
        setTimeout(function() {
          var $reloadedForm = $('#follow-up-form-' + followUpId);
          if ($reloadedForm.length > 0) {
            $reloadedForm.find('.reinspection-form').each(function() {
              initializeReinspectionForm(this);
            });
            updateReinspectionNumbers($reloadedForm[0]);
          }
        }, 100);
      }
    });
  });
});
